import { en } from './en';
import { de } from './de';

export type Language = 'en' | 'de';

export const translations = {
  en,
  de,
} as const;

// Type-safe translation key path
export type TranslationKeyPath = 
  | `nav.${keyof typeof en.nav}`
  | `common.${keyof typeof en.common}`
  | `homepage.hero.${keyof typeof en.homepage.hero}`
  | `homepage.features.${keyof typeof en.homepage.features}`
  | `homepage.testimonials.${keyof typeof en.homepage.testimonials}`
  | `homepage.stats.${keyof typeof en.homepage.stats}`
  | `homepage.cta.${keyof typeof en.homepage.cta}`
  | `partnerSuccess.hero.${keyof typeof en.partnerSuccess.hero}`
  | `partnerSuccess.benefits.${keyof typeof en.partnerSuccess.benefits}`
  | `partnerSuccess.howItWorks.${keyof typeof en.partnerSuccess.howItWorks}`
  | `partnerSuccess.roi.${keyof typeof en.partnerSuccess.roi}`
  | `partnerSuccess.faq.${keyof typeof en.partnerSuccess.faq}`
  | `travelerExperience.hero.${keyof typeof en.travelerExperience.hero}`
  | `travelerExperience.features.${keyof typeof en.travelerExperience.features}`
  | `travelerExperience.testimonials.${keyof typeof en.travelerExperience.testimonials}`
  | `travelerExperience.offers.${keyof typeof en.travelerExperience.offers}`
  | `viennaDiscovery.hero.${keyof typeof en.viennaDiscovery.hero}`
  | `viennaDiscovery.stats.${keyof typeof en.viennaDiscovery.stats}`
  | `viennaDiscovery.districts.${keyof typeof en.viennaDiscovery.districts}`
  | `viennaDiscovery.hiddenGems.${keyof typeof en.viennaDiscovery.hiddenGems}`
  | `viennaDiscovery.quiz.${keyof typeof en.viennaDiscovery.quiz}`
  | `hostProgram.hero.${keyof typeof en.hostProgram.hero}`
  | `hostProgram.benefits.${keyof typeof en.hostProgram.benefits}`
  | `hostProgram.howItWorks.${keyof typeof en.hostProgram.howItWorks}`
  | `hostProgram.community.${keyof typeof en.hostProgram.community}`
  | `hostProgram.faq.${keyof typeof en.hostProgram.faq}`
  | `footer.${keyof typeof en.footer}`;